export default "__VITE_ASSET__Dlp4r$gd__"